<div class="appointments-container">
  <!-- Header Section -->
  <div class="appointments-header">
    <h3 class="appointments-title">Appointments</h3>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading appointments...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <div class="error-message">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p>{{ error }}</p>
    </div>
    <button class="btn btn-outline retry-btn" (click)="retry()">
      <span>Try Again</span>
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !error && appointments.length === 0" class="empty-state-container">
    <div class="empty-state-content">
      <div class="empty-state-illustration">
        <img src="assets/images/empty-state-illustration.svg" alt="No appointments illustration" />
      </div>
      <div class="empty-state-text">
        <h3 class="empty-state-title">No Appointments Found</h3>
        <p class="empty-state-description">There are no appointment records available for this customer.</p>
      </div>
    </div>
  </div>

  <!-- Appointments List -->
  <div *ngIf="!loading && !error && appointments.length > 0" class="appointments-list">
    <div 
      *ngFor="let appointment of appointments; trackBy: trackById" 
      class="appointment-card">
      
      <!-- Card Content -->
      <div class="card-content">
        <!-- Header Section -->
        <div class="card-header-section">
          <!-- Top Row -->
          <div class="card-top-row">
            <div class="package-info">
              <h4 class="package-name">{{ appointment.package_name }}</h4>
            </div>
            
            <!-- Status Chip -->
            <div class="status-chip" [ngClass]="appointment.appointment_status">
              <span class="status-text">{{ appointment.appointment_status }}</span>
            </div>
          </div>

          <!-- Details Section -->
          <div class="details-section">
            <div class="price-text">{{ getFormattedPrice(appointment) }} <span class="currency-period">/month</span></div>
            <!-- Info Grid -->
            <div class="info-grid">
              <div class="info-row">
                <!-- Date Info -->
                <div class="info-item">
                  <div class="info-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.334 2.5V5.83333M6.66732 2.5V5.83333M3.33398 9.16667H16.6673M9.16732 12.5H10.0007V15M3.33398 5.83333C3.33398 5.39131 3.50958 4.96738 3.82214 4.65482C4.1347 4.34226 4.55862 4.16667 5.00065 4.16667H15.0006C15.4427 4.16667 15.8666 4.34226 16.1792 4.65482C16.4917 4.96738 16.6673 5.39131 16.6673 5.83333V15.8333C16.6673 16.2754 16.4917 16.6993 16.1792 17.0118C15.8666 17.3244 15.4427 17.5 15.0006 17.5H5.00065C4.55862 17.5 4.1347 17.3244 3.82214 17.0118C3.50958 16.6993 3.33398 16.2754 3.33398 15.8333V5.83333Z" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </div>
                  <span class="info-text">{{ getFormattedDate(appointment) }}</span>
                </div>

                <!-- Vehicle Info -->
                <div class="info-item">
                  <div class="info-icon">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.16602 14.6667C4.16602 15.1087 4.34161 15.5326 4.65417 15.8452C4.96673 16.1577 5.39065 16.3333 5.83268 16.3333C6.27471 16.3333 6.69863 16.1577 7.01119 15.8452C7.32375 15.5326 7.49935 15.1087 7.49935 14.6667C7.49935 14.2246 7.32375 13.8007 7.01119 13.4882C6.69863 13.1756 6.27471 13 5.83268 13C5.39065 13 4.96673 13.1756 4.65417 13.4882C4.34161 13.8007 4.16602 14.2246 4.16602 14.6667ZM12.4993 14.6667C12.4993 15.1087 12.6749 15.5326 12.9875 15.8452C13.3001 16.1577 13.724 16.3333 14.166 16.3333C14.608 16.3333 15.032 16.1577 15.3445 15.8452C15.6571 15.5326 15.8327 15.1087 15.8327 14.6667C15.8327 14.2246 15.6571 13.8007 15.3445 13.4882C15.032 13.1756 14.608 13 14.166 13C13.724 13 13.3001 13.1756 12.9875 13.4882C12.6749 13.8007 12.4993 14.2246 12.4993 14.6667Z" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M4.16667 14.6667H2.5V9.66667M2.5 9.66667L4.16667 5.5H11.6667L15 9.66667M2.5 9.66667H15M15 9.66667H15.8333C16.2754 9.66667 16.6993 9.84226 17.0118 10.1548C17.3244 10.4674 17.5 10.8913 17.5 11.3333V14.6667H15.8333M12.5 14.6667H7.5M10 9.66667V5.5" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </div>
                  <span class="info-text">{{ getVehicleInfo(appointment) }}</span>
                </div>
              </div>

              <div class="info-row">
                <!-- Location Info -->
                <div class="info-item">
                  <div class="info-icon">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 9.66602C7.5 10.3291 7.76339 10.9649 8.23223 11.4338C8.70107 11.9026 9.33696 12.166 10 12.166C10.663 12.166 11.2989 11.9026 11.7678 11.4338C12.2366 10.9649 12.5 10.3291 12.5 9.66602C12.5 9.00297 12.2366 8.36709 11.7678 7.89825C11.2989 7.42941 10.663 7.16602 10 7.16602C9.33696 7.16602 8.70107 7.42941 8.23223 7.89825C7.76339 8.36709 7.5 9.00297 7.5 9.66602Z" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14.7148 14.3806L11.179 17.9164C10.8665 18.2286 10.4428 18.404 10.0011 18.404C9.55933 18.404 9.13567 18.2286 8.82315 17.9164L5.28649 14.3806C4.35417 13.4482 3.71927 12.2603 3.46206 10.9671C3.20485 9.67395 3.3369 8.33352 3.84149 7.11537C4.34608 5.89721 5.20057 4.85604 6.29689 4.12351C7.39321 3.39098 8.68213 3 10.0007 3C11.3192 3 12.6081 3.39098 13.7044 4.12351C14.8007 4.85604 15.6552 5.89721 16.1598 7.11537C16.6644 8.33352 16.7965 9.67395 16.5392 10.9671C16.282 12.2603 15.6471 13.4482 14.7148 14.3806Z" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      
                  </div>
                  <span class="info-text">{{ getLocationInfo(appointment) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- View Appointment Button -->
        <div>
          <button class="btn btn-primary btn-small mt-24" (click)="onViewAppointment(appointment.id)">
            <span>View Appointment</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.33 8h9.34M10 4.67L13.33 8L10 11.33" stroke="#FFFFFF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div> 